import React, { Component } from 'react';

class SaveExpressCareSetsModal extends Component {
  render() {
    const { onSave, selectedSetsCount } = this.props;
    return (
      <div
        className="modal fade theme-modal" id="saveExpressCareSetsModal"
        tabIndex="-1" aria-labelledby="saveExpressCareSetsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>{`You have planned a total of ${selectedSetsCount} ${selectedSetsCount > 1 ? 'sets' : 'set'}.
                ${selectedSetsCount > 1 ? 'These sets' : 'This set'} will be added to Office Notes for the office staff to process.
                Is
                this correct ?`}
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">No</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onSave()}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaveExpressCareSetsModal;
